module.exports = __webpack_public_path__ + "static/media/temp_wody_off.f0d29599.svg";